import { useCurrentLocationDispatch } from './useCurrentLocationDispatch';
import { useCurrentLocationState } from './useCurrentLocationState';

/**
 * Use the current location context provided by the provider
 *
 * @returns [The current client, The update local storage function]
 */
export function useCurrentLocation(): [
    ReturnType<typeof useCurrentLocationState>,
    ReturnType<typeof useCurrentLocationDispatch>,
] {
    return [useCurrentLocationState(), useCurrentLocationDispatch()];
}
